import { TheWestSection } from '@news-mono/common'
import { StaticRoutes } from '@news-mono/web-common'
import { aflMatchCentreRoutes } from './afl-match-centre-routes'
import { getEmailPreferenceRouteInfo } from './email-preference'
import { ePaper, ePaperSubscribe } from './ePaper'
import { theWestPageIsUnavailableRoute } from './errors'
import { getBaliBombingsMyStoryRouteInfo } from './features/bali-bombings-my-story'
import { bestAustralianYarnRoute } from './features/best-australian-yarn'
import { getBikieCodeRouteInfo } from './features/bikie-code'
import { getBlakDeathsInCustodyRouteInfo } from './features/blak-deaths-in-custody'
import { getElectionFactCheckerRouteInfo } from './features/fact-checker'
import { getFoulPlayRouteInfo } from './features/foul-play'
import { getGenesisRouteInfo } from './features/genesis-ballet'
import { getLisaGovanRouteInfo } from './features/lisa-govan'
import { queenElizabethTributesRoute } from './features/queen-elizabeth-tribute'
import { getWestTonightRouteInfo } from './features/the-west-tonight'
import { getTradingUpRouteInfo } from './features/trading-up'
import { getUpLateRouteInfo } from './features/up-late'
import { getYourStoryOurStoryRouteInfo } from './features/your-story-our-story'
import { homepage } from './home'
import { pollieRater } from './pollieRater'
import { puzzles } from './puzzles'
import { regionalRoutes } from './regionals'
import { staticContentRoutes } from './static/static-content-routes'
import { getSwgRouteInfo } from './subscribe-with-google'
import { getTeachersOfferRouteInfo } from './teachers-offer'
import { getUniversityOfferRouteInfo } from './university-offer'
import { customTopicRoutes } from './topic/custom-topic-routes'
import { liveScoresRoute } from './topic/custom/get-live-scores-route-info'
import { upgradeAppRoute } from './upgrade-app-route-info'
import { westlive } from './west-live'

export const staticRoutes: StaticRoutes<TheWestSection> = {
    ...pollieRater,
    ...puzzles,
    ...staticContentRoutes,
    ...customTopicRoutes,
    ...homepage,
    ...regionalRoutes,
    ...westlive,
    ...ePaper,
    ...ePaperSubscribe,
    ...getYourStoryOurStoryRouteInfo,
    ...getLisaGovanRouteInfo,
    ...getEmailPreferenceRouteInfo,
    ...getSwgRouteInfo,
    ...getBlakDeathsInCustodyRouteInfo,
    ...getGenesisRouteInfo,
    ...upgradeAppRoute,
    ...getWestTonightRouteInfo,
    ...getUpLateRouteInfo,
    ...getTradingUpRouteInfo,
    ...liveScoresRoute,
    ...getElectionFactCheckerRouteInfo,
    ...theWestPageIsUnavailableRoute,
    ...getFoulPlayRouteInfo,
    ...queenElizabethTributesRoute,
    ...bestAustralianYarnRoute,
    ...getBaliBombingsMyStoryRouteInfo,
    ...getBikieCodeRouteInfo,
    ...getTeachersOfferRouteInfo,
    ...getUniversityOfferRouteInfo,
    ...aflMatchCentreRoutes,
}
